import React, { Component } from "react";
import { Table, Card, Row, Col, Button, Image } from "react-bootstrap";
// import StateViewModal from "../State/StateViewModal";
import AddDistrict from "./AddDistrict";
import EditDistrict from "./EditDistrict";
import DeleteDistrict from "./DeleteDistrict";
import "../../Common/Common.css";
import "./District.css";
import ReactPaginate from "react-paginate";
class District extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userShow: false,
      ShowAddModel: false,
      showEditModel: false,
      ItemList: "",
      ItemDelList: "",
      showDelModel: false,
      searchShow: false,
      perPage: 10,
      page: 0,
      Spage: 0,
      FltrPage: 0,
      perPageS: 10,
      perPagef: 10,
      searchDistrict: "",
      filterValue: "All",
      FilterTable: false,
    };
    this.editmodel = this.editmodel.bind(this);
    this.closeEditModel = this.closeEditModel.bind(this);
    this.showDelDisModel = this.showDelDisModel.bind(this);
    this.closeDelModel = this.closeDelModel.bind(this);
  }
  handleShowAdd = () => {
    this.setState({
      ShowAddModel: true,
      FilterTable: false,
      searchShow: false,
      filterValue: "All",
    });
  };
  handleClose = () => {
    this.setState({ ShowAddModel: false });
  };
  componentDidMount() {
    this.props.fetchState();
    this.props.fetchDistrict();
  }
  editmodel(item) {
    this.setState({
      showEditModel: true,
      ItemList: item,
    });
  }
  closeEditModel() {
    this.setState({
      showEditModel: false,
    });
  }
  showDelDisModel = (item) => {
    this.setState({
      showDelModel: true,
      ItemDelList: item,
    });
  };
  closeDelModel() {
    this.setState({
      showDelModel: false,
    });
  }

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;

    this.props.locSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  handlePageSearchClick = (e) => {
    const selectedSearchPage = e.selected;

    this.setState({ Spage: selectedSearchPage });

    this.props.districtSearch({
      searchDistrict: this.state.searchDistrict,
      Spage: selectedSearchPage + 1,
      value: this.state.filterValue,
    });
  };

  SearchOnChange = (event) => {
    let district = event.target.value;
    const hasSearch = district !== "";
    const hasFilter = this.state.filterValue !== "All";

    this.setState({
      searchShow: hasSearch,
      searchDistrict: district,
      FilterTable: !hasSearch && hasFilter,
      page: 0,
      Spage: 0,
      FltrPage: 0,
    });

    if (hasSearch) {
      this.props.districtSearch({
        searchDistrict: district,
        Spage: 1,
        value: this.state.filterValue,
      });
    } else if (hasFilter) {
      this.props.districtFilter({
        page: 1,
        value: this.state.filterValue,
      });
    } else {
      this.props.fetchDistrict();
    }
  };

  handleChange = (event) => {
    const filterValue = event.target.value;
    this.setState({
      FltrPage: 0,
      page: 0,
      Spage: 0,
      filterValue,
    });
    if (this.state.searchDistrict) {
      this.setState({
        searchShow: true,
        FilterTable: false,
      });
      this.props.districtSearch({
        searchDistrict: this.state.searchDistrict,
        Spage: 1,
        value: filterValue,
      });
    } else if (filterValue === "All") {
      this.setState({
        FilterTable: false,
        searchShow: false,
      });
      this.props.fetchDistrict();
    } else {
      this.props.districtFilter({
        page: 1,
        value: event.target.value,
      });
      this.setState({ FilterTable: true });
    }
  };

  handlePageFltrClick = (e) => {
    const selectedFltrPage = e.selected;
    this.setState({ FltrPage: selectedFltrPage });
    this.props.districtFilter({
      page: selectedFltrPage + 1,
      value: this.state.filterValue,
    });
  };

  render() {
    const count = this.props.districtDtlsCount && this.props.districtDtlsCount;
    let p = this.state.page + 1;
    let locPageCount = Math.ceil(count / this.state.perPage);

    const searchCount =
      this.props.DistrictSearchCount && this.props.DistrictSearchCount;
    let p1 = this.state.Spage + 1;
    let searchPageCount = Math.ceil(searchCount / this.state.perPageS);

    let p3 = this.state.FltrPage + 1;
    const FltrCount =
      this.props.FilterDistrictCount && this.props.FilterDistrictCount;
    const fltrPageCount = Math.ceil(FltrCount / this.state.perPagef);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>District</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="All">All</option>
                    {this.props.stateList &&
                      this.props.stateList.map((item, i) => (
                        <option key={i} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Search by District"
                      value={this.state.searchDistrict}
                      onChange={this.SearchOnChange}
                    />
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count === undefined &&
                    searchCount === undefined &&
                    FltrCount === undefined ? (
                      0
                    ) : (
                      <span>
                        {!this.state.searchShow &&
                          !this.state.FilterTable &&
                          count}
                        {this.state.searchShow &&
                          !this.state.FilterTable &&
                          searchCount}
                        {this.state.FilterTable && FltrCount}
                      </span>
                    )}
                  </span>
                  <span style={{ opacity: ".7" }}>Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Button
              className="btn_district_add"
              onClick={() => this.handleShowAdd()}
            >
              <i className="fa fa-plus fa-md"></i>
              <span style={{ marginLeft: "5px", fontWeight: "bold" }}>ADD</span>
            </Button>
            <AddDistrict
              ShowAddModel={this.state.ShowAddModel}
              handleClose={this.handleClose}
              stateList={this.props.stateList}
              addDistrict={this.props.addDistrict}
              resetPage={this.resetPage}
            />
            {!this.state.searchShow && !this.state.FilterTable && (
              <div className="DisMainTable">
                <Table responsive striped className="cmnMainTable" bordered>
                  <thead style={{ textAlign: "center" }}>
                    <tr className="cmnMainTableHd">
                      <th style={{ width: "40px" }}>SL NO</th>

                      <th style={{ width: "150px" }}>STATE </th>
                      <th style={{ width: "150px" }}>DISTRICT </th>
                      <th style={{ width: "70px" }}>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.DistrictList &&
                      this.props.DistrictList.map((item, i) => (
                        <tr key={i}>
                          <td>{10 * (p - 1) + i + 1}</td>
                          {}
                          <td className="cmn_Cap">{item.stateId.name}</td>
                          <td className="cmn_Cap">{item.name}</td>
                          <td className="cmnViewIcon">
                            {" "}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-edit fa-lg"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.editmodel(item)}
                              ></i>
                              <EditDistrict
                                showEditModel={this.state.showEditModel}
                                closeEditModel={this.closeEditModel}
                                ItemList={this.state.ItemList}
                                editDistrict={this.props.editDistrict}
                                stateList={this.props.stateList}
                                resetPage={this.resetPage}
                              />
                              <i
                                className="fa fa-trash fa-lg"
                                style={{
                                  paddingLeft: 10,
                                  cursor: "pointer",
                                }}
                                onClick={() => this.showDelDisModel(item)}
                              ></i>
                              <DeleteDistrict
                                showDelModel={this.state.showDelModel}
                                closeDelModel={this.closeDelModel}
                                ItemDelList={this.state.ItemDelList}
                                deleteDistrict={this.props.deleteDistrict}
                                resetPage={this.resetPage}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}

            {/* -----------------------search--------------------------- */}
            {this.state.searchShow && !this.state.FilterTable && (
              <div className="DisMainTable">
                <Table responsive striped className="cmnMainTable" bordered>
                  <thead style={{ textAlign: "center" }}>
                    <tr className="cmnMainTableHd">
                      <th style={{ width: "50px" }}>SL NO</th>
                      <th style={{ width: "150px" }}>STATE </th>
                      <th style={{ width: "150px" }}>DISTRICT </th>
                      <th style={{ width: "70px" }}>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.DistrictListSearch &&
                      this.props.DistrictListSearch.map((item, i) => (
                        <tr key={i}>
                          <td>{10 * (p1 - 1) + i + 1}</td>
                          <td className="cmn_Cap">{item.stateId.name}</td>
                          <td className="cmn_Cap">{item.name}</td>
                          <td className="cmnViewIcon">
                            {" "}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-edit fa-lg"
                                onClick={() => this.editmodel(item)}
                              ></i>
                              <EditDistrict
                                showEditModel={this.state.showEditModel}
                                closeEditModel={this.closeEditModel}
                                ItemList={this.state.ItemList}
                                editDistrict={this.props.editDistrict}
                                stateList={this.props.stateList}
                                resetPage={this.resetPage}
                              />
                              <i
                                className="fa fa-trash fa-lg"
                                style={{
                                  paddingLeft: 10,
                                }}
                                onClick={() => this.showDelDisModel(item)}
                              ></i>
                              <DeleteDistrict
                                showDelModel={this.state.showDelModel}
                                closeDelModel={this.closeDelModel}
                                ItemDelList={this.state.ItemDelList}
                                deleteDistrict={this.props.deleteDistrict}
                                resetPage={this.resetPage}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}

            {/* **************************************Filter************************** */}

            {this.state.FilterTable && (
              <div className="DisMainTable">
                <Table responsive striped className="cmnMainTable" bordered>
                  <thead style={{ textAlign: "center" }}>
                    <tr className="cmnMainTableHd">
                      <th style={{ width: "50px" }}>SL NO</th>

                      <th style={{ width: "150px" }}>STATE </th>
                      <th style={{ width: "150px" }}>DISTRICT </th>
                      <th style={{ width: "70px" }}>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.FilterDistrictList &&
                      this.props.FilterDistrictList.map((item, i) => (
                        <tr key={i}>
                          <td>{10 * (p3 - 1) + i + 1}</td>
                          <td className="cmn_Cap">{item.stateId.name}</td>
                          <td className="cmn_Cap">{item.name}</td>
                          <td className="cmnViewIcon">
                            {" "}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-edit fa-lg"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.editmodel(item)}
                              ></i>
                              <EditDistrict
                                showEditModel={this.state.showEditModel}
                                closeEditModel={this.closeEditModel}
                                ItemList={this.state.ItemList}
                                editDistrict={this.props.editDistrict}
                                stateList={this.props.stateList}
                                resetPage={this.resetPage}
                              />
                              <i
                                className="fa fa-trash fa-lg"
                                style={{
                                  paddingLeft: 10,
                                  cursor: "pointer",
                                }}
                                onClick={() => this.showDelDisModel(item)}
                              ></i>
                              <DeleteDistrict
                                showDelModel={this.state.showDelModel}
                                closeDelModel={this.closeDelModel}
                                ItemDelList={this.state.ItemDelList}
                                deleteDistrict={this.props.deleteDistrict}
                                resetPage={this.resetPage}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}

            {!this.state.searchShow &&
              !this.state.FilterTable &&
              (this.props.DistrictList === undefined ||
                (this.props.DistrictList &&
                  this.props.DistrictList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Districts Found</div>
                </div>
              )}

            {this.state.searchShow &&
              !this.state.FilterTable &&
              (this.props.DistrictListSearch === undefined ||
                (this.props.DistrictListSearch &&
                  this.props.DistrictListSearch.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Districts Found</div>
                </div>
              )}

            {!this.state.searchShow &&
              this.state.FilterTable &&
              (this.props.FilterDistrictList === undefined ||
                (this.props.FilterDistrictList &&
                  this.props.FilterDistrictList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Districts Found</div>
                </div>
              )}
          </Card.Body>

          {!this.state.searchShow &&
          !this.state.FilterTable &&
          locPageCount &&
          locPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={locPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}

          {this.state.searchShow &&
          !this.state.FilterTable &&
          searchPageCount &&
          searchPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.Spage}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={searchPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageSearchClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}

          {this.state.FilterTable && fltrPageCount && fltrPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.FltrPage}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={fltrPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageFltrClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default District;
